import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export const PRACTICE_AGENT_SIDEBAR_BUTTON_ID = 'practice-agent-sidebar-button';

export type PracticeAgentWidgetOpenResult = 'no-relevant-card' | 'card-api-failed' | 'already-open-elsewhere' | 'temporarily-unavailable';

@Injectable({ providedIn: 'root' })
export class PracticeAgentWidgetControlService {
  private readonly openRequestSubject = new Subject<void>();
  private readonly visibleSubject = new BehaviorSubject(false);
  private readonly collapsedSubject = new BehaviorSubject(false);
  private readonly badgeMovingSubject = new BehaviorSubject(false);
  private readonly enabledSubject = new BehaviorSubject(false);
  private readonly homePageActiveSubject = new BehaviorSubject(false);
  private readonly openResultSubject = new BehaviorSubject<PracticeAgentWidgetOpenResult | null>(null);
  private readonly availableSubject = new BehaviorSubject(false);
  private readonly notificationCountSubject = new BehaviorSubject<number | null>(null);

  readonly openRequested$ = this.openRequestSubject.asObservable();
  readonly visible$ = this.visibleSubject.asObservable();
  readonly collapsed$ = this.collapsedSubject.asObservable();
  readonly badgeMoving$ = this.badgeMovingSubject.asObservable();
  readonly enabled$ = this.enabledSubject.asObservable();
  readonly homePageActive$ = this.homePageActiveSubject.asObservable();
  readonly openResult$ = this.openResultSubject.asObservable();
  readonly available$ = this.availableSubject.asObservable();
  readonly notificationCount$ = this.notificationCountSubject.asObservable();

  openWidget(): void {
    this.setCollapsed(false);
    this.openResultSubject.next(null);
    this.openRequestSubject.next();
  }

  setVisible(visible: boolean): void {
    if (!visible) {
      this.setCollapsed(false);
    }
    this.visibleSubject.next(visible);
    if (visible) {
      this.openResultSubject.next(null);
    }
  }

  setCollapsed(collapsed: boolean): void {
    this.collapsedSubject.next(collapsed);
  }

  setBadgeMoving(moving: boolean): void {
    this.badgeMovingSubject.next(moving);
  }

  setHomePageActive(active: boolean): void {
    this.homePageActiveSubject.next(active);
  }

  setEnabled(enabled: boolean): void {
    if (!enabled) {
      this.setCollapsed(false);
    }
    this.enabledSubject.next(enabled);
  }

  setOpenResult(result: PracticeAgentWidgetOpenResult | null): void {
    this.openResultSubject.next(result);
  }

  setAvailable(available: boolean): void {
    this.availableSubject.next(available);
  }

  setNotificationCount(count: number | null): void {
    this.notificationCountSubject.next(count);
  }
}
